module.exports = __webpack_public_path__ + "img/keys.a06acd2e.png";